<div class="page-container" data-cy="oauth-popup-callback_message">
  <p>Connecting your {{ providerLabel }}&hellip; you can close this window.</p>
</div>
